






import Vue, {PropType} from 'vue'
import {
    PaginationData,
    SspStatistic,
} from '@/types'

import {Column, ColumnItems, ColumnType, FilterTypeField, Row} from "@/components/table/types";
import {Chart} from 'highcharts-vue'

export default Vue.extend({
    name: 'Cart',
    mounted() {
    },
    components: {
        Chart
    },
    computed: {},
    methods: {},
    data: function () {
        return {
            options: {
                series: [
                    {
                        data: [1, 2, 3]
                    }
                ]
            }
        }
    }
})
